import { Show, splitProps, Suspense } from 'solid-js';
import { clientOnly } from '@solidjs/start';
import { useSearchParams } from '@solidjs/router';
import { ErrorBoundary } from '../components/error-boundary';
import { BaseLayout } from './base';
import type { ComponentProps } from 'solid-js';

type Props = ComponentProps<typeof BaseLayout>;

const WelcomeModal = clientOnly(async () => ({ default: (await import('../components/welcome-modal')).WelcomeModal }));

export function GenericLayout(props: Props) {
	const [searchParams] = useSearchParams<{ welcome?: string }>();
	const [local, rest] = splitProps(props, ['children']);
	return (
		<BaseLayout {...rest}>
			<ErrorBoundary contained>
				{local.children}
				<Show when={!!searchParams.welcome}>
					<Suspense>
						<WelcomeModal />
					</Suspense>
				</Show>
			</ErrorBoundary>
		</BaseLayout>
	);
}
